import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBar, MessageBarType, Spinner } from '@fluentui/react';
import { useApiDownState } from './useApiDownState';
/** Default message displayed in the MessageApiDown component */
export const TEXT_API_DOWN_MESSAGE_DEFAULT = `The servers are down for maintenance right now. Please save your work and try again later.`;
/**
 * Premade messagebar component that periodically polls the API health url
 * to confirm whether backend services are up.
 */
export const MessageApiDown = ({ children = TEXT_API_DOWN_MESSAGE_DEFAULT, apiList, pollingFrequency = 16, }) => {
    const { apiUp, appInStartup, isLoading } = useApiDownState({
        apiList,
        pollingFrequency,
    });
    if (apiUp || appInStartup) {
        return null;
    }
    return (_jsxs(MessageBar, Object.assign({ messageBarType: MessageBarType.blocked }, { children: [children, isLoading && _jsx(Spinner, {})] })));
};
